let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aY86J")).then(() => parcelRequire('iEgJa'));